import { Pipe, PipeTransform } from '@angular/core';

type ScoreCardTradeGroupItem = Record<string, string | undefined>;

@Pipe({
  name: 'tradeGroupName',
  standalone: false,
})
export class ScoreCardTradeGroupNamePipe implements PipeTransform {
  transform(
    items: ScoreCardTradeGroupItem[],
    fieldToCompare: string,
    fieldToReturn: string,
    value: string
  ): string {
    const item = items.find((x) => x[fieldToCompare] === value);
    return item && item[fieldToReturn]
      ? 'Trade Group: ' + item[fieldToReturn]
      : '';
  }
}
